import React from "react";
import "./favoriteIcon.css";

const FavoriteIcon = ({
  className = "",
  isFavorited = false,
  loading = false,
  onToggle,
}) => {
  const handleClick = (e) => {
    e.stopPropagation();
    if (!loading && onToggle) {
      onToggle();
    }
  };

  return (
    <button
      className={`favorite-icon-btn ${className}`}
      onClick={handleClick}
      disabled={loading}
      aria-label={isFavorited ? "Remove from favorites" : "Add to favorites"}
    >
      <span
        className={`material-symbols-outlined favorite-icon ${
          isFavorited ? "favorite-icon--filled" : ""
        }`}
        style={{ fontVariationSettings: `'FILL' ${isFavorited ? 1 : 0}` }}
      >
        favorite
      </span>
    </button>
  );
};

export default FavoriteIcon;
